import Dartboard from './Dartboard';

export default Dartboard;
